import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from '#src/components/layouts/InfoLayout.tsx';

const CreditTerms = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'CreditTerms.path',
          defaultMessage: 'CREDIT_TERMS.md',
        })}
        skipHtml
      />
    </InfoLayout>
  );
};

export default CreditTerms;
